var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Repeat = function Repeat(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M6.293 2.293a1 1 0 0 1 1.414 1.414L6.414 5H17a4 4 0 0 1 4 4v3a1 1 0 1 1-2 0V9a2 2 0 0 0-2-2H6.414l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3ZM3 12a1 1 0 1 1 2 0v3a2 2 0 0 0 2 2h10.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L17.586 19H7a4 4 0 0 1-4-4v-3Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Repeat;